import * as React from "react";

const SvgIcnHoldBoldSmall = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path d="M0 0h24v24H0z" />
            <path
                d="M7.667 5h2.666c.369 0 .667.348.667.778v12.444c0 .43-.298.778-.667.778H7.667C7.298 19 7 18.652 7 18.222V5.778c0-.43.298-.778.667-.778zM13.667 5h2.666c.369 0 .667.348.667.778v12.444c0 .43-.298.778-.667.778h-2.666c-.369 0-.667-.348-.667-.778V5.778c0-.43.298-.778.667-.778z"
                fill="currentColor"
                fillRule="nonzero"
            />
        </g>
    </svg>
);

export default SvgIcnHoldBoldSmall;
